import env from "../utils/env";
import { prepareHttpHeaders } from "../utils/http";

export function downloadFile(url, filename) {
  const headers = prepareHttpHeaders();

  fetch(env("BASE_URL") + url, {
    responseType: "arraybuffer",
    headers: new Headers(headers)
  }).then(async function (response) {
    if (!response.ok) {
      throw new Error(`Failed to download file`);
    }

    const b = await response.blob();
    const a = document.createElement("a");

    a.href = URL.createObjectURL(b);
    a.setAttribute("download", filename);
    a.click();
  });
}
